<template>
  <section
    v-if="freeCancellation.isEnabled"
    v-track:impression="{ event: 'search:freeCancellationImpression' }"
    class="border-suc items-center gap-2 rounded-lg border p-1 md:p-2"
  >
    <WebccIcon name="site/tick" class="text-suc h-4 w-4 md:h-5 md:w-5" />
    <div class="grow-0 text-xs md:text-sm">
      <span class="font-semibold">{{ $t(`${trPrefix}title`) }}</span
      >: <span>{{ $t(`${trPrefix}text`) }}&nbsp;</span>
      <span class="font-semibold">{{ freeCancellation.lastDateShort }}</span>
    </div>
    <span v-if="showTooltip" v-tooltip="{ content: tooltip, html: true }"
      ><WebccIcon name="site/info-new" class="text-txt-weak h-5 w-5"
    /></span>
  </section>
</template>

<script setup lang="ts">
const trPrefix = 'plugins.components.FreeCancellationInfo.'

const { t } = useI18n()

const props = withDefaults(
  defineProps<{
    trip: Partial<TripParams>
    showTooltip?: boolean
    cancelConditions?: CancelCondition[]
  }>(),
  {
    showTooltip: false,
    cancelConditions: () => [],
  },
)

const freeCancellation = useFreeCancellation(
  () => props.trip,
  () => props.cancelConditions,
)

const tooltip = computed(() => {
  const title = t(`${trPrefix}tooltipTitle`)
  const text = t(`${trPrefix}tooltipText`, {
    date: freeCancellation.lastDateFull ?? '',
  })

  return `<div class='max-w-[24rem] px-6 py-3'><p class='font-semibold mb-4'>${title}</p> <p>${text}</p></div>`
})
</script>
